<template>
  <div>
    <template v-if="!loading">
      <protocol-header v-if="protocol"
                       :protocol="protocol"
                       :task="task"></protocol-header>
      
      <hr>
      
      <amendment-header v-if="amendment"
                        :amendment="amendment"></amendment-header>
      
      <div class="mt-2 mb-4">
        <h5 class="my-3">Dictamen de protocolo por: {{ committee.name }}</h5>
        
        <committee-dictum-amendments-tabs :protocol="amendment.protocol"
                                          :amendment="amendment"
                                          @show-section="showSection"></committee-dictum-amendments-tabs>
      </div>
      
      <component :is="currentSection"
                 :committee="committee"
                 :protocol="protocol"
                 :amendment="amendment"
                 :task="task"
                 :readonly="readonly"
                 :readonlyFiles="readonlyFiles"
                 :evaluating="true"
                 :hide-headers="true"
                 @register-dictum="registerCommitteeDictum"
                 @show-comments="showComments"
                 @cancel-reviewer="confirmCancelReviewer"
                 @resend-invitation="resendInvitationReviewer"></component>
    </template>
    
    <div v-else
         class="text-center">
      <div class="spinner-border text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    
    <portal to="task-modals-main">
      <users-modal ref="users-modal"
                   :selected-users="assignedReviewers"
                   :load-users-function="loadUsers"
                   @user-selected="addReviewerToAmendment"></users-modal>
      
      <comments-modal id="comments-modal"
                      ref="comments-modal"
                      :comments="comments"
                      title="Comentarios del dictamen"></comments-modal>
      
      <ok-cancel-dialog id="cancel-reviewer-modal"
                        ref="cancel-reviewer-modal"
                        :content="'<p>¿Está seguro de cancelar la invitación al revisor?</p>'"
                        title="Cancelar participación de revisor"
                        @ok-button-pressed="cancelReviewer"
                        @cancel-button-pressed="cancelingReviewerCancelled"></ok-cancel-dialog>
    
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import GeneralInformation from '../amendments/committee-dictums/GeneralInformation'
  import DictumAmendment from '../amendments/committee-dictums/DictumAmendment'
  import PreviousStageReport from '../protocols/committee-dictums/PreviousStageReport'
  import CancelProtocol from '../protocols/committee-dictums/CancelProtocol'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import UsersModal from '../../components/users/UsersModal'
  import ProtocolHeader from './ProtocolHeader'
  import AmendmentHeader from '../amendments/AmendmentHeader'
  import AmendmentTitle from '../amendments/AmendmentTitle'
  import AmendmentCancellation from '../amendments/AmendmentCancellation'
  import AmendmentExtension from '../amendments/AmendmentExtension'
  import AmendmentProtocol from '../amendments/AmendmentProtocol'
  import AmendmentResearchers from '../amendments/AmendmentResearchers'
  import AmendmentResponsible from '../amendments/AmendmentResponsible'
  import CommentsModal from './committee-dictums/CommentsModal'
  import CommitteeDictumAmendmentsTabs from './commons/CommitteeDictumAmendmentsTabs'
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'CommitteeDictumAmendment',
    components: {
      CommitteeDictumAmendmentsTabs,
      GeneralInformation,
      DictumAmendment,
      PreviousStageReport,
      CancelProtocol,
      OkCancelDialog,
      ProtocolHeader,
      UsersModal,
      CommentsModal,
      AmendmentHeader,
      AmendmentTitle,
      AmendmentProtocol,
      AmendmentExtension,
      AmendmentCancellation,
      AmendmentResponsible,
      AmendmentResearchers,
    },
    data () {
      return {
        currentSection: 'GeneralInformation',
        sidebarActive: false,
        loading: true,
        comments: null,
        userId: null,
        readonly: true,
        readonlyFiles: false,
      }
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
      committee: Object,
      amendment: Object,
    },
    computed: {
      ...mapGetters({
        committees: 'committees/committees',
        reviewers: 'amendments/reviewers',
        dates: 'amendments/dates',
        dictums: 'amendments/dictums',
        committeeDictums: 'amendments/committeeDictums',
      }),
      
      assignedReviewers () {
        if (this.protocol && this.protocol.researchers) {
          return this.reviewers.concat(this.protocol.researchers)
        }
        
        return this.reviewers
      },
    },
    methods: {
      ...mapActions({
        getCommittees: 'committees/getCommittees',
        getReviewers: 'amendments/getReviewers',
        getCommitteeDictums: 'amendments/getCommitteeDictums',
        getAssignedReviewers: 'amendments/getAssignedReviewers',
        addReviewer: 'amendments/addReviewer',
        saveCommitteeDictum: 'amendments/saveCommitteeDictum',
        loadUsers: 'users/getResearchers',
        cancelReviewerInvitation: 'amendments/cancelReviewer',
        resendInvitation: 'amendments/resendReviewerInvitation',
      }),
      
      toggleSidebar () {
        this.sidebarActive = !this.sidebarActive
      },
      
      showSection (section) {
        if (section === 'AssignReviewers') {
          $(this.$refs['amendment-tabs']).find('.nav-link').removeClass('active')
          $(this.$refs['amendment-tabs']).find('.nav-link:first-child').addClass('active')
          
          return this.showUsersListModal()
        }
        
        if (section === 'ShowAmendment') {
          return this.showAmendment()
        }
        
        if (section === 'DictumAmendment' && this.dates.length <= this.committeeDictums.length) {
          AlertManager.error('Por favor asigne una fecha de reunión.')
          return false
        }
        
        this.currentSection = section
        this.toggleSidebar()
      },
      
      // TODO: Complete this.
      showAmendment () {
        const amendmentTypes = {
          'cambio_titulo': 'AmendmentTitle',
          'investigador_responsable': 'AmendmentResponsible',
          'coinvestigadores': 'AmendmentResearchers',
          'prorroga': 'AmendmentExtension',
          'cancelacion_proyecto': 'AmendmentCancellation',
          'protocolo': 'AmendmentProtocol',
        }
        
        this.currentSection = amendmentTypes[this.amendment.type.key]
      },
      
      async load () {
        this.loading = true
        
        const {
                amendment,
                committee,
              } = this
        
        await this.getCommittees({
          key: committee.key,
        })
        
        await this.getReviewers({
          amendment: this.amendment,
          committee: this.committee.id,
        })
        
        await this.getCommitteeDictums({
          amendment,
          committee,
        })
        
        this.loading = false
      },
      
      showUsersListModal () {
        this.$refs['users-modal'].load()
      },
      
      async addReviewerToAmendment (researcher, callback) {
        const { amendment } = this
        
        const response = await this.addReviewer({
          amendment,
          researcher,
          committee: this.committees[0],
        })
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        await this.getAssignedReviewers({
          amendment,
          committee: this.committees[0],
        })
        
        AlertManager.success(message)
        
        if (callback) {
          callback(response)
        }
      },
      
      async registerCommitteeDictum (dictum, callback) {
        try {
          const response = await this.saveCommitteeDictum(dictum)
          
          const {
                  status,
                  error,
                  message,
                } = response.data.data
          
          if (status === 'error') {
            AlertManager.error(error)
            
            return false
          }
          
          AlertManager.success(message)
          
          this.$emit('close-task')
        } catch (e) {
          if (e.response && e.response.status === 422) {
            const $validator = $('#frm-dictum').validate()
            
            $validator.showErrors(e.response.data.errors)
          }
        }
        
        if (callback) {
          callback()
        }
      },
      showComments (comments) {
        this.comments = comments
        
        this.$refs['comments-modal'].open()
      },
      confirmCancelReviewer (userId) {
        this.userId = userId
        
        $(this.$refs['cancel-reviewer-modal'].$el).modal()
      },
      async cancelReviewer (userId) {
        if (!this.userId) {
          return false
        }
        
        this.$refs['cancel-reviewer-modal'].sending = true
        
        const {
                amendment,
                committee,
              } = this
        
        const response = await this.cancelReviewerInvitation({
          committee,
          amendment,
          researcher: this.userId,
        })
        
        const {
                message,
                status,
                error,
              } = response.data.data
        
        $(this.$refs['cancel-reviewer-modal'].$el).modal('hide')
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        // Reload reviewers table.
        await this.getAssignedReviewers({
          amendment,
          committee: this.committees[0],
        })
      },
      cancelingReviewerCancelled () {
        this.userId = null
      },
      
      async resendInvitationReviewer (userId) {
        const {
                amendment,
                committee,
              } = this
        
        const response = await this.resendInvitation({
          amendment,
          committee,
          researcher: userId,
        })
        
        const {
                error,
                message,
                status,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.success(message)
        
        await this.load()
      },
    },
    async mounted () {
      await this.load()
    },
  }
</script>
